import styled from 'styled-components';
import { Text } from '@lux/text';
import { FunctionColor, FontSize } from '@lux/core';
import { CampaignCardMiniWrapper } from '@client/components/mylounge/campaigns/components/campaign-card-mini.styles';
import { CarouselCardNewDealsTodayWrapper } from '@client/components/mylounge/new-deals-today/carousel-card-new-deals-today.styles';

export const Container = styled.div`
    display: flex;
    margin: 0;
`;

export const SpecialText = styled(Text)<{ $isPlusVariant?: boolean }>`
    justify-content: center;
    align-self: flex-end;
    padding-left: 10px;

    ${({ $isPlusVariant }) => $isPlusVariant && `color: #ffffff !important;`}

    ${CampaignCardMiniWrapper} & {
        padding-left: 0;
        font-size: ${FontSize.S};
    }

    ${CarouselCardNewDealsTodayWrapper} & {
        padding-left: 0;
        font-size: ${FontSize.S};
    }
`;

export const RegularContainer = styled.span<{ oneline?: boolean }>`
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: right;
    text-transform: lowercase;

    /*  Styling Specific for CampaignCardMini
        Remove When CampaignCardMini Removed     */
    ${CampaignCardMiniWrapper} & {
        display: block;
    }

    /*  Styling Specific for CarouselCardNewDealsToday     */
    ${CarouselCardNewDealsTodayWrapper} & {
        display: block;
    }
`;
export const RegularText = styled(Text)<{ $isPlusVariant?: boolean }>`
    padding-left: 10px;

    ${({ $isPlusVariant }) => $isPlusVariant && `color: #ffffff !important;`}

    /*  Styling Specific for CampaignCardMini
        Remove When CampaignCardMini Removed     */
    ${CampaignCardMiniWrapper} & {
        padding-left: 0px;
        font-size: ${FontSize.S};
    }

    /*  Styling Specific for CarouselCardNewDealsToday     */
    ${CarouselCardNewDealsTodayWrapper} & {
        padding-left: 0px;
        font-size: ${FontSize.S};
    }
`;

export const RRPRegularText = styled(Text)<{ $isPlusVariant?: boolean }>`
    padding-left: 10px;
    text-transform: initial;

    text-align: right;

    ${({ $isPlusVariant }) => $isPlusVariant && `color: #ffffff !important;`}

    .discount {
        font-weight: bold;
        color: ${({ $isPlusVariant }) => ($isPlusVariant ? '#ffffff' : FunctionColor.function100)};
    }

    .br {
        display: block;
    }

    ${CampaignCardMiniWrapper} & {
        padding-left: 0px;
        font-size: ${FontSize.S};
    }

    ${CarouselCardNewDealsTodayWrapper} & {
        padding-left: 0px;
        font-size: ${FontSize.S};
    }
`;

export const MaxDiscountText = styled(Text)<{ $isPlusVariant?: boolean }>`
    text-align: right;
    ::before {
        content: ' ';
    }

    ${({ $isPlusVariant }) => $isPlusVariant && `color: #ffffff !important;`}

    /*  Styling Specific for CampaignCardMini
        Remove When CampaignCardMini Removed     */
    ${CampaignCardMiniWrapper} & {
        font-size: ${FontSize.S};
    }

    /*  Styling Specific for CarouselCardNewDealsToday     */
    ${CarouselCardNewDealsTodayWrapper} & {
        font-size: ${FontSize.S};
    }
`;
